<template>
  <v-card
    outlined
    rounded="lg"
    elevation="1"
  >
    <v-list-item two-line>
      <v-list-item-avatar>
        <v-icon
          x-large
          color="primary"
        >
          mdi-account-circle
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">
          {{ caseInfo.patient }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ caseInfo.title }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <!-- Menu List -->
          <v-list>
            <!-- view details -->
            <router-link
              class="black--text option-link" 
              :to="`cases/${caseInfo.id}`"
            >
              <v-list-item
                dense link
              >
                <v-list-item-icon class="mr-3"><v-icon>mdi-eye</v-icon></v-list-item-icon>
                <v-list-item-title>View</v-list-item-title>
              </v-list-item>
            </router-link>
            <!-- delete -->
            <v-list-item
              dense link
            >
              <v-list-item-icon class="mr-3"><v-icon color="error">mdi-delete-outline</v-icon></v-list-item-icon>
              <v-list-item-title class="red--text">Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>        
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>

<script>
  export default {
    name: 'CaseCard',

    props: {
      caseInfo: {
        type: Object,
        default() {
          return {
            patient: '',
            title: ''
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.option-link {
  text-decoration: none;
}
</style>